import Axios from "axios";
import { authorizationHeader } from "./apiUtils";
import { CustomNecklace, UpsertCustomNecklace } from "../models/necklaces";

const routes = {
  customNecklaces: "/api/custom_necklaces",
  customNecklace: "/api/custom_necklaces/{id}",
  import: "/api/custom_necklaces/import",
};

const getAllCustomNecklaces = async (): Promise<CustomNecklace[]> => {
  const route = `${routes.customNecklaces}`;

  const result = await Axios.get<CustomNecklace[]>(route, {
    headers: authorizationHeader(),
  });

  return result.data;
};

// const addGenericDiamond = async (diamond: UpsertGenericDiamond): Promise<UpsertGenericDiamond> => {
//   const result = await Axios.post<UpsertGenericDiamond>(routes.genericDiamonds, diamond, {
//     headers: authorizationHeader(),
//   });

//   return result.data;
// };

// const editGenericDiamond = async (id: number, model: UpsertGenericDiamond): Promise<void> => {
//   const route = routes.genericDiamond.replace("{id}", id.toString());
//   await Axios.patch(route, model, {
//     headers: authorizationHeader(),
//   });
// };

const importCsv = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);

  await Axios.post(routes.import, formData, {
    headers: authorizationHeader(),
  });
};

export {
  getAllCustomNecklaces,
  // addGenericDiamond,
  // editGenericDiamond,
  importCsv,
};
